import isFunction from 'lodash/isFunction';
import { Checkbox } from 'primereact/checkbox';
import React from 'react';
import { SegmentEventTypes } from '../../data/tracking';
import Analytics from '../../utils/Analytics';
import LabelWrapper from '../LabelWrapper.component';

export const WrappedCheckbox = props => {
	const {
		children,
		inputId,
		dataqa = 'common',
		onChange,
		isInputInvalid,
		...rest
	} = props;

	const clickHandler = e => {
		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'checkbox',
				field_name_dataqa: `ui-checkedbox-${dataqa}`,
				field_value: e.checked,
			},
			eventType: SegmentEventTypes.UserInteraction,
		});

		if (isFunction(onChange)) {
			onChange(e);
		}
	};

	return (
		<div className="common-ui-checkbox" data-qa={`ui-checkedbox-${dataqa}`}>
			<Checkbox
				inputId={inputId}
				dataqa={`ui-checkedbox-${dataqa}`}
				onChange={clickHandler}
				{...rest}
			/>
			{children && (
				<label htmlFor={inputId} className="p-checkbox-label">
					{children}
				</label>
			)}
		</div>
	);
};

export const WrappedCheckboxWithLabel = LabelWrapper(WrappedCheckbox);
